var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBracket = function SvgBracket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.749 19.994V18.25c-1.437 0-1.78-.604-1.78-1.913v-2.065c0-.982-.379-1.812-2.03-2.152v-.24c1.651-.34 2.03-1.177 2.03-2.159V7.657c0-1.303.343-1.907 1.78-1.907V4c-2.446 0-3.884.636-3.884 3.474V9.08c0 1.322-.477 1.864-1.865 1.864v2.114c1.388 0 1.865.542 1.865 1.864v1.598c0 2.839 1.438 3.475 3.884 3.475M14.251 4.006V5.75c1.437 0 1.78.604 1.78 1.913v2.065c0 .982.379 1.813 2.03 2.152v.24c-1.651.34-2.03 1.177-2.03 2.159v2.064c0 1.303-.343 1.907-1.78 1.907V20c2.446 0 3.884-.636 3.884-3.474V14.92c0-1.322.477-1.864 1.865-1.864v-2.114c-1.388 0-1.865-.542-1.865-1.864V7.481c0-2.839-1.438-3.475-3.884-3.475"
  })));
};
export default SvgBracket;